import React from 'react';
import Button from '@material-ui/core/Button';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import apiClient from '../../apiClient';
import './UserForm.scss';
import SharedDetails from '../../Components/SharedDetails/SharedDetails';
import { AppBar, Tab, Tabs, Typography, Box, Dialog, DialogTitle, DialogContent, DialogActions, TextField } from "@material-ui/core";
import Role from '../Role/Role';
const Panel = (props) => (
    <div hidden={props.value !== props.index}>
      <Typography>{props.children}</Typography>
    </div>
  );

/** Normalize DB values so they match table lookup keys and MenuItem values */
function normalizeUserType(value) {
    if (value == null || value === '') return 'sales person';
    const s = String(value).trim().toLowerCase();
    if (s === 'admin') return 'admin';
    if (s === 'sales person' || s === 'salesperson' || s === 'sale person' || s === 'saleperson') {
        return 'sales person';
    }
    return 'sales person';
}

const normalizeUserRows = (rows) => (rows || []).map((row) => ({
    ...row,
    UserType: normalizeUserType(row.UserType),
}));

const userCsvHeaders = [
    { label: 'User Name', key: 'Name' },
    { label: 'Email', key: 'Email' },
    { label: 'User Type', key: 'UserType' },
];


export default class UserForm extends React.Component {

   
    state = {
        listVersion: 0,
        formData: {
            email: '',
            name: '',
            password: '',
            userType: '',
        },
        submitted: false,
        successMessage:null,
        index:0,
        isAdmin: false,
        currentUserId: null,
        resetDialogOpen: false,
        resetTargetUser: null,
        resetPassword: '',
        resetPasswordConfirm: '',
        resetError: null,
        rowUpdateError: null,
    }

    a11yProps(index) {
      return {
        id: `scrollable-auto-tab-${index}`,
        'aria-controls': `scrollable-auto-tabpanel-${index}`,
      };
    }

    getAuthHeaders() {
        try {
            const u = JSON.parse(sessionStorage.getItem('user')) || {};
            return { Authorization: `Bearer ${u.accessToken || ''}` };
        } catch (e) {
            return { Authorization: 'Bearer ' };
        }
    }

    componentDidMount() {
        let user = JSON.parse(sessionStorage.getItem('user'));
        const isAdmin = user && user.role === 'admin';
        const currentUserId = user && user.userId != null ? user.userId : null;
        this.setState({ isAdmin, currentUserId });

        if(user.permissions.filter(x=>x.PermissionName == 'User' && x.PermissionAllowed == 1).length == 0)
            {
              const { history } = this.props;
              history.push('/home');
            }
      }

    handleChange = (event) => {
        const { formData } = this.state;
        formData[event.target.name] = event.target.value;
        this.setState({ formData });
    }

    handleSubmit = () => {
        this.setState({ submitted: true }, () => {
            setTimeout(() => this.setState({ 
                formData: {
                    email: '',
                    name: '',
                    password: '',
                    userType: '',
                },
                submitted: false
             }), 5000);
        });

        /**
         * POST REQUEST
         */
        const { formData } = this.state;
        apiClient.post(`/api/post/user`, { formData }, { headers: this.getAuthHeaders() })
      .then(res => {
          const result = res.data;
          this.setState({ result });
        this.setState((state) => ({
            successMessage: 'Successfully saved!',
            listVersion: state.listVersion + 1,
        }));

       
        setTimeout(() => {
          this.setState({ successMessage: null });
        }, 3000);
      })
    }

    openResetPasswordDialog = (rowData) => {
        this.setState({
            resetDialogOpen: true,
            resetTargetUser: rowData,
            resetPassword: '',
            resetPasswordConfirm: '',
            resetError: null,
        });
    }

    closeResetPasswordDialog = () => {
        this.setState({
            resetDialogOpen: false,
            resetTargetUser: null,
            resetPassword: '',
            resetPasswordConfirm: '',
            resetError: null,
        });
    }

    handleResetPasswordChange = (event) => {
        this.setState({ [event.target.name]: event.target.value, resetError: null });
    }

    submitResetPassword = () => {
        const { resetPassword, resetPasswordConfirm, resetTargetUser } = this.state;
        if (!resetPassword) {
            this.setState({ resetError: 'Password is required.' });
            return;
        }
        if (resetPassword !== resetPasswordConfirm) {
            this.setState({ resetError: 'Passwords do not match.' });
            return;
        }
        apiClient.put(
            `/api/put/user-password`,
            { userId: resetTargetUser.UserID, newPassword: resetPassword },
            { headers: this.getAuthHeaders() }
        )
            .then(() => {
                this.setState({
                    resetDialogOpen: false,
                    resetTargetUser: null,
                    resetPassword: '',
                    resetPasswordConfirm: '',
                    successMessage: `Password reset for ${resetTargetUser.Name}.`,
                });
                setTimeout(() => this.setState({ successMessage: null }), 3000);
            })
            .catch((err) => {
                const msg = (err.response && err.response.data && err.response.data.error) || 'Could not reset password.';
                this.setState({ resetError: msg });
            });
    }

    onTabClicked = (event, newValue) => {
      this.setState({ index: newValue });
  }

    render() {
      sessionStorage.setItem('TranSearch', null);
      sessionStorage.setItem('ItemTabIndex', JSON.stringify(0));
        const { formData, submitted, isAdmin, currentUserId } = this.state;
        const tableColumns = [
            { title: 'User ID', field: 'UserID', hidden: true },
            { title: 'User Name', field: 'Name', editable: false },
            { title: 'Email', field: 'Email', editable: false },
            {
                title: 'User Type',
                field: 'UserType',
                // Limit this field to row updates when the current user is an admin.
                editable: isAdmin ? 'onUpdate' : false,
                lookup: { admin: 'Admin', 'sales person': 'Sale Person' },
                cellStyle: { overflow: 'visible' },
            },
        ];
        const tableActions = isAdmin
            ? [
                  (rowData) => ({
                      icon: 'vpn_key',
                      tooltip: 'Reset password (other users only)',
                      hidden:
                          currentUserId != null &&
                          Number(rowData.UserID) === Number(currentUserId),
                      onClick: () => this.openResetPasswordDialog(rowData),
                  }),
              ]
            : [];
        const editableConfig = isAdmin
            ? {
                  onRowUpdate: (newData, oldData) =>
                      new Promise((resolve, reject) => {
                          const oldId = Number(oldData.UserID);
                          const selfId = currentUserId != null ? Number(currentUserId) : null;
                          if (selfId != null && !Number.isNaN(oldId) && oldId === selfId) {
                              this.setState({ rowUpdateError: 'You cannot change your own user type here.' });
                              reject();
                              return;
                          }
                          if (newData.UserType === oldData.UserType) {
                              resolve();
                              return;
                          }
                          this.setState({ rowUpdateError: null });
                          apiClient
                              .put(
                                  `/api/put/user-type`,
                                  { userId: oldId, userType: newData.UserType },
                                  { headers: this.getAuthHeaders() }
                              )
                              .then(() => {
                                  this.setState((state) => ({
                                      successMessage: 'User type updated.',
                                      rowUpdateError: null,
                                      listVersion: state.listVersion + 1,
                                  }));
                                  setTimeout(() => this.setState({ successMessage: null }), 3000);
                                  resolve();
                              })
                              .catch((err) => {
                                  const msg =
                                      (err.response && err.response.data && err.response.data.error) ||
                                      err.message ||
                                      'Could not update user type. Try logging out and back in if you are an admin.';
                                  this.setState({ rowUpdateError: msg });
                                  reject();
                              });
                      }),
              }
            : undefined;

        return (
       
<Box className='Tab' >
                    <AppBar position="static">
                        <Tabs value={this.state.index} onChange={this.onTabClicked}>
                        <Tab label="Users" {...this.a11yProps(0)} />
                        <Tab label="Roles" {...this.a11yProps(1)}/>
                        </Tabs>
                    </AppBar>
                    <Panel value={this.state.index} index={0}>
                    <div className="UserForm">

                    <ValidatorForm
                ref="form"
                onSubmit={this.handleSubmit}
            >
                <h2>User Form</h2>
                <TextValidator
                    label="Email"
                    onChange={this.handleChange}
                    name="email"
                    value={formData.email}
                    validators={['isEmail']}
                    errorMessages={['this field is required', 'email is not valid']}
                />
                <br />
                <TextValidator
                    label="User Name"
                    onChange={this.handleChange}
                    name="name"
                    maxlength="8"
                    value={formData.name}
                    validators={['required']}
                    errorMessages={['this field is required']}
                />
                <br />
              
                <TextValidator
                    label="Password"
                    onChange={this.handleChange}
                    name="password"
                    value={formData.password}
                    validators={['required']}
                    errorMessages={['this field is required']}
                />
                 <br />

                 <FormControl  margin="normal">
						<InputLabel id="select-label">Select Type</InputLabel>
						<Select
                            label="userType"
                            name="userType" 
                            value={formData.userType}
                            onChange={this.handleChange}
                            margin="normal"
                            displayEmpty
                            inputProps={{ 'aria-label': 'Without label' }} >
                         <MenuItem value="">  </MenuItem>
                        <MenuItem value="admin">  Admin</MenuItem>
                        <MenuItem value="sales person">  SalePerson</MenuItem>
										
						 </Select>  
           </FormControl>
              
               
                <br /><br /><br />
                <Button
                    color="primary"
                    variant="contained"
                    type="submit"
                    disabled={submitted}
                >
                    {
                        (submitted && 'Your form is submitted!')
                        || (!submitted && 'Submit')
                    }
                </Button>
                
                {this.state.successMessage && (
          <div
            style={{
              backgroundColor: '#28a745',
              color: '#fff',
              padding: '10px',
              marginTop: '10px',
            }}
          >
            {this.state.successMessage}
          </div>
        )}
              
            </ValidatorForm>
            <div style={{ maxWidth: '100%', paddingTop: '50px' }}>
                {isAdmin && (
                    <Typography variant="body2" style={{ marginTop: 8, marginBottom: 8 }}>
                        As an admin, you can edit User Type in the table (not your own row) and use the key icon to reset another user&apos;s password.
                    </Typography>
                )}
                {this.state.rowUpdateError && (
                    <div
                        style={{
                            backgroundColor: '#dc3545',
                            color: '#fff',
                            padding: '10px',
                            marginBottom: '12px',
                        }}
                    >
                        {this.state.rowUpdateError}
                    </div>
                )}
                <SharedDetails
                csvFilename="user-details.csv"
                csvHeaders={userCsvHeaders}
                columns={tableColumns}
                actions={tableActions}
                editable={editableConfig}
                emptyMessage="No user records found."
                errorMessage="Unable to load users. Please try again."
                loadingMessage="Loading users..."
                pagedEndpoint="/api/get/user/paged"
                reloadKey={this.state.listVersion}
                style={{ maxWidth: '100%' }}
                tableOptions={{
                    actionsColumnIndex: -1,
                }}
                title="User Details"
                transformRows={normalizeUserRows}
                />


                
            </div>
            <Dialog open={this.state.resetDialogOpen} onClose={this.closeResetPasswordDialog} maxWidth="xs" fullWidth>
                <DialogTitle>Reset password</DialogTitle>
                <DialogContent>
                    {this.state.resetTargetUser && (
                        <Typography variant="body2" style={{ marginBottom: 16 }}>
                            Set a new password for <strong>{this.state.resetTargetUser.Name}</strong>.
                        </Typography>
                    )}
                    <TextField
                        margin="dense"
                        label="New password"
                        name="resetPassword"
                        type="password"
                        fullWidth
                        value={this.state.resetPassword}
                        onChange={this.handleResetPasswordChange}
                    />
                    <TextField
                        margin="dense"
                        label="Confirm password"
                        name="resetPasswordConfirm"
                        type="password"
                        fullWidth
                        value={this.state.resetPasswordConfirm}
                        onChange={this.handleResetPasswordChange}
                    />
                    {this.state.resetError && (
                        <Typography color="error" variant="body2" style={{ marginTop: 8 }}>
                            {this.state.resetError}
                        </Typography>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.closeResetPasswordDialog} color="default">
                        Cancel
                    </Button>
                    <Button onClick={this.submitResetPassword} color="primary" variant="contained">
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
            </div>
                    </Panel>
                    <Panel value={this.state.index} index={1}>
                      <Role />
                    </Panel>
                    </Box>
          
                  
           

           
        
        
        );
    }
}
